import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import Shell from "../components/Shell";
import ExamList from "../components/ExamList";
import { useAuth } from "../lib/auth";
import { api } from "../lib/api";
export default function StudentView() {
    const { student, user } = useAuth();
    const [rows, setRows] = useState(null);
    useEffect(() => {
        if (!student)
            return;
        (async () => {
            const { rows } = await api.get(`/api/students/${student.id}/scores`);
            setRows(rows);
        })();
    }, [student]);
    if (!student) {
        return (_jsx(Shell, { children: _jsx("p", { className: "text-slate2 text-sm", children: "Your student profile isn't linked yet. Ask an admin to link your login to your student record." }) }));
    }
    return (_jsxs(Shell, { children: [_jsxs("div", { className: "mb-5", children: [_jsxs("div", { className: "eyebrow", children: ["Marks \u00B7 ", user?.display_name] }), _jsx("h1", { className: "font-display text-3xl mt-1", children: student.full_name }), _jsxs("div", { className: "text-slate2 text-sm mt-1", children: ["Grade ", student.class_id] })] }), rows === null ? _jsx("p", { className: "text-slate2 text-sm", children: "Loading\u2026" }) : _jsx(ExamList, { rows: rows })] }));
}
